import { useMemo, ReactNode } from 'react'
import Markdown from 'markdown-to-jsx'
import cn from 'clsx'
import styles from './markdown.css'

type MarkdownProps = {
  className?: string
  children: string
}

const elements = [
  'a',
  'abbr',
  'address',
  'area',
  'article',
  'aside',
  'audio',
  'b',
  'base',
  'bdi',
  'bdo',
  'big',
  'blockquote',
  'body',
  'br',
  'button',
  'canvas',
  'caption',
  'cite',
  'code',
  'col',
  'colgroup',
  'data',
  'datalist',
  'dd',
  'del',
  'details',
  'dfn',
  'dialog',
  'div',
  'dl',
  'dt',
  'em',
  'embed',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hgroup',
  'hr',
  'html',
  'i',
  'iframe',
  'img',
  'input',
  'ins',
  'kbd',
  'keygen',
  'label',
  'legend',
  'li',
  'link',
  'main',
  'map',
  'mark',
  'marquee',
  'menu',
  'menuitem',
  'meta',
  'meter',
  'nav',
  'noscript',
  'object',
  'ol',
  'optgroup',
  'option',
  'output',
  'p',
  'param',
  'picture',
  'pre',
  'progress',
  'q',
  'rp',
  'rt',
  'ruby',
  's',
  'samp',
  'script',
  'section',
  'select',
  'small',
  'source',
  'span',
  'strong',
  'style',
  'sub',
  'summary',
  'sup',
  'table',
  'tbody',
  'td',
  'textarea',
  'tfoot',
  'th',
  'thead',
  'time',
  'title',
  'tr',
  'track',
  'u',
  'ul',
  'var',
  'video',
  'wbr',

  // SVG
  'circle',
  'clipPath',
  'defs',
  'ellipse',
  'foreignObject',
  'g',
  'image',
  'line',
  'linearGradient',
  'marker',
  'mask',
  'path',
  'pattern',
  'polygon',
  'polyline',
  'radialGradient',
  'rect',
  'stop',
  'svg',
  'text',
  'tspan',
]

const allowedElements = ['a', 'b', 'strong', 'em', 'u', 'p']

const MarkdownComponent = ({ children, className }: MarkdownProps) => {
  const options = useMemo(() => {
    const opts = {
      overrides: {
        a: {
          component: 'a',
          props: {
            rel: 'noopener noreferrer',
            target: '_blank',
          },
        },
      },
    }

    elements.forEach(element => {
      if (!allowedElements.includes(element)) {
        opts.overrides[element] = ({ children: child }: { children: ReactNode }) => <span>{child}</span>
      }
    })

    return opts
  }, [])
  return (
    <div className={cn(styles.wrapper, className)}>
      <Markdown options={options}>{`${children}`}</Markdown>
    </div>
  )
}

export default MarkdownComponent
